import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TinymceModule } from 'angular4-tinymce-biznet';

import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { MainModule } from '../main/main.module';
import { AuditModule } from '../audit/audit.module';
import { IncidentsModule } from '../incidents/incidents.module';
import { StatisticsModule } from '../statistics/statistics.module';

import { environment } from '../../environments/environment';
import { BuildingsComponent } from './buildings/buildings.component';
import { BuildingListItemComponent } from './building-list-item/building-list-item.component';
import { BuildingSheetComponent } from './building-sheet/building-sheet.component';
import { BuildingFormComponent } from './building-form/building-form.component';
import { DatasheetComponent } from './datasheet/datasheet.component';
import { GlobalDataProvider } from '../main/Models/global.model.provider';
import { TranslocoRootModule } from '../transloco/transloco-root.module';

let tinymceBaseUrl = window['__env'].baseUrl+'/miiar/assets/tinymce/';

@NgModule({
  imports: [
    CommonModule, FormsModule, RouterModule,
    CustomMaterialModule, TranslocoRootModule,
    MainModule, AuditModule, IncidentsModule, StatisticsModule,
    TinymceModule.withConfig({
        language: 'fr_FR',
        height: 600,
        theme: 'modern',
        skin_url: tinymceBaseUrl+'skins/lightgray',
        external_plugins: {
          image: tinymceBaseUrl+'plugins/image/plugin.js',
          imagetools: tinymceBaseUrl+'plugins/imagetools/plugin.js',
          textcolor: tinymceBaseUrl+'plugins/textcolor/plugin.js',
          colorpicker: tinymceBaseUrl+'plugins/colorpicker/plugin.js',
          table: tinymceBaseUrl+'plugins/table/plugin.js',
          pagebreak: tinymceBaseUrl+'/plugins/pagebreak/plugin.js',
          lists: tinymceBaseUrl+'/plugins/lists/plugin.min.js',
          code: tinymceBaseUrl+'/plugins/code/plugin.js',
          fullscreen: tinymceBaseUrl+'/plugins/fullscreen/plugin.js',
          //paste: tinymceBaseUrl+'/plugins/paste/plugin.min.js',
          //poodll: tinymceBaseUrl+'/plugins/poodll/poodll.js',
        },
        toolbar: 'undo redo | styleselect | bold italic | numlist bullist | alignleft aligncenter alignright alignjustify | link  image imagetools | forecolor backcolor table',
        images_upload_handler: function (blobInfo, success, failure) {
          success('data:image/png;base64,'+blobInfo.base64());
        }
      })
  ],
  declarations: [
  	BuildingsComponent, BuildingListItemComponent, BuildingSheetComponent, BuildingFormComponent, DatasheetComponent
  ],
  exports: [
  	BuildingsComponent, BuildingListItemComponent, BuildingSheetComponent, BuildingFormComponent
  ],
  providers: [GlobalDataProvider]
})
export class BuildingsModule { }
